import React, { FC } from 'react';
import { MyOrderFragment, OrderItem_Booking_Fragment, OrderItem_Ticket_Fragment } from '../generated/graphql';
import OrderItemTile from './OrderItemTile';
import createUnitTitle from '../utils/createUnitTitle';
import { useIntl } from 'react-intl';
import { isDeclined } from '../utils/order';

interface Props {
    data: MyOrderFragment;
}

const Orders: FC<React.PropsWithChildren<Props>> = ({ data }) => {
    const { orderItems, id, number } = data;

    const bookingOrders = orderItems.filter(item => item.__typename === 'Booking');
    const orderItemBooking = bookingOrders.map(item => item as OrderItem_Booking_Fragment);

    const ticketOrders = orderItems.filter(item => item.__typename === 'Ticket');
    const orderItemTicket = ticketOrders.map(item => item as OrderItem_Ticket_Fragment);
    const { formatMessage } = useIntl();
    const getHour = (date: string) => date.split(' ').pop();
    return (
        <>
            {orderItemBooking.map((item, i) => (
                <OrderItemTile
                    key={item.id ?? i}
                    thumbnail={item.rentalUnit?.jpegThumbnail}
                    webThumbnail={item.rentalUnit?.webpThumbnail}
                    orderItemTitle={
                        item.rentalUnit
                            ? createUnitTitle(
                                  item.rentalUnit.name,
                                  item.rentalUnit.accommodation.name,
                                  item.rentalUnit.accommodation.hasPublicPage
                              )
                            : formatMessage({ defaultMessage: 'Deze accommodatie is niet meer beschikbaar' })
                    }
                    arrivalDate={item.arrivalDate}
                    departureDate={item.departureDate}
                    orderItemTypeName="Accommodatie"
                    orderId={id!}
                    orderNumber={number}
                    voucherUrl={item.downloadVoucherUrl!}
                    alterable={item.isAlterable}
                    cancellable={item.isCancellable && !isDeclined(item)}
                    itemId={item.id!}
                    isUnavailable={!item.rentalUnit}
                    orderItemType="Accomodation"
                    isCancelled={isDeclined(item)}
                />
            ))}
            {orderItemTicket.map((item, i) => (
                <OrderItemTile
                    key={i}
                    thumbnail={item.activity?.jpegThumbnail}
                    webThumbnail={item.activity?.webpThumbnail}
                    orderItemTitle={
                        item.activity
                            ? item.activity.name
                            : formatMessage({ defaultMessage: 'Deze activiteit is niet meer beschikbaar' })
                    }
                    arrivalDate={item.timeslot?.startDateTime!}
                    departureDate={item.timeslot?.endDateTime!}
                    isUnavailable={!item.activity}
                    orderItemTypeName="Activiteit"
                    orderId={data.id!}
                    orderNumber={number}
                    voucherUrl={item.downloadVoucherUrl!}
                    orderItemType="Activity"
                    duration={getHour(item.startDateTime)}
                    isCancelled={isDeclined(item)}
                />
            ))}
        </>
    );
};

export default Orders;
